import React, { isValidElement } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function IconRenderer({
  icon,
  className,
  size = 24,
  title
}) {
  if (!icon) {
    return null;
  }
  const isFC = typeof icon === 'object' && Object.prototype.hasOwnProperty.call(icon, 'render');
  if (isFC) {
    const IconFC = icon;
    return /*#__PURE__*/_jsx(IconFC, {
      size: size,
      className: className,
      title: title
    });
  }
  if (/*#__PURE__*/isValidElement(icon)) {
    return icon;
  }
  throw new Error('Unexpected icon input');
}